'use strict';
import * as $j_app$002edata$002e$002dForm$002dQuantity$0024given$005f$002dExtract$005f$002dForm$002dQuantity$0024 from "./app.data.-Form-Quantity$given_-Extract_-Form-Quantity$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_InvoiceLineItemForm(name, unitPrice, quantity, quantityUnit, vatRate, grossWeight, netWeight, discount, referenceNumber) {
  this.aC0 = null;
  this.lm = null;
  this.l2 = null;
  this.l0 = null;
  this.l1 = null;
  this.i8 = null;
  this.kd = null;
  this.ke = null;
  this.j1 = null;
  this.kH = null;
  this.lm = name;
  this.l2 = unitPrice;
  this.l0 = quantity;
  this.l1 = quantityUnit;
  this.i8 = vatRate;
  this.kd = grossWeight;
  this.ke = netWeight;
  this.j1 = discount;
  this.kH = referenceNumber;
  this.aC0 = $j_app$002edata$002e$002dForm$002dQuantity$0024given$005f$002dExtract$005f$002dForm$002dQuantity$0024.$m_Lapp_data_FormQuantity$given\uff3fExtract\uff3fFormQuantity$();
}
export { $c_Lapp_data_InvoiceLineItemForm as $c_Lapp_data_InvoiceLineItemForm };
$p = $c_Lapp_data_InvoiceLineItemForm.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_InvoiceLineItemForm;
/** @constructor */
function $h_Lapp_data_InvoiceLineItemForm() {
}
export { $h_Lapp_data_InvoiceLineItemForm as $h_Lapp_data_InvoiceLineItemForm };
$h_Lapp_data_InvoiceLineItemForm.prototype = $p;
$p.IB = (function() {
  return this.aC0;
});
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_InvoiceLineItemForm)) {
    if ((this.lm === x$0.lm)) {
      var x = this.l2;
      var x$2 = x$0.l2;
      var $x_6 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$3 = this.l0;
      var x$4 = x$0.l0;
      var $x_5 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_5 = false;
    }
    if (($x_5 && (this.l1 === x$0.l1))) {
      var x$5 = this.i8;
      var x$6 = x$0.i8;
      var $x_4 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$7 = this.kd;
      var x$8 = x$0.kd;
      var $x_3 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$9 = this.ke;
      var x$10 = x$0.ke;
      var $x_2 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$11 = this.j1;
      var x$12 = x$0.j1;
      var $x_1 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$13 = this.kH;
      var x$14 = x$0.kH;
      return ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 9;
});
$p.t = (function() {
  return "InvoiceLineItemForm";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.lm;
      break;
    }
    case 1: {
      return this.l2;
      break;
    }
    case 2: {
      return this.l0;
      break;
    }
    case 3: {
      return this.l1;
      break;
    }
    case 4: {
      return this.i8;
      break;
    }
    case 5: {
      return this.kd;
      break;
    }
    case 6: {
      return this.ke;
      break;
    }
    case 7: {
      return this.j1;
      break;
    }
    case 8: {
      return this.kH;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "name";
      break;
    }
    case 1: {
      return "unitPrice";
      break;
    }
    case 2: {
      return "quantity";
      break;
    }
    case 3: {
      return "quantityUnit";
      break;
    }
    case 4: {
      return "vatRate";
      break;
    }
    case 5: {
      return "grossWeight";
      break;
    }
    case 6: {
      return "netWeight";
      break;
    }
    case 7: {
      return "discount";
      break;
    }
    case 8: {
      return "referenceNumber";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.Kb = (function() {
  return this.l2;
});
$p.Es = (function() {
  return this.l0;
});
$p.agr = (function() {
  return this.l1;
});
$p.bxa = (function() {
  return this.i8;
});
$p.aey = (function() {
  return this.j1;
});
$p.a5q = (function() {
  return this.kd;
});
$p.a5O = (function() {
  return this.ke;
});
function $isArrayOf_Lapp_data_InvoiceLineItemForm(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jF)));
}
export { $isArrayOf_Lapp_data_InvoiceLineItemForm as $isArrayOf_Lapp_data_InvoiceLineItemForm };
var $d_Lapp_data_InvoiceLineItemForm = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_InvoiceLineItemForm, "app.data.InvoiceLineItemForm", ({
  jF: 1,
  eC: 1,
  jA: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_InvoiceLineItemForm as $d_Lapp_data_InvoiceLineItemForm };
//# sourceMappingURL=app.data.-Invoice-Line-Item-Form.js.map
